import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Card, Col, Row } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { errorNotify } from "../../../../../Utils/toast";
import { getUserOrderDetails } from "../../../../../Redux/Actions/UserOrders";
import Loader from "../../../../../Utils/Loader";
import moment from 'moment';
import { downloadFile, cloudBaseURL, downloadS3File } from '../../../../../Utils/helper'
import OrderIcon from "../../../../../Assets/images/orders.png";

type State = { a: any };
type AppDispatch = ThunkDispatch<State, any, AnyAction>;

const OrderDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { error, loading, orderDetails } = useSelector((state: any) => state.userOrderDetails);
  const digitizerStatus = orderDetails?.data?.digitizer_order_status
  const dispatch: AppDispatch = useDispatch();
  const [downloadableFile, setDownloadAbleFile] = useState<string>('');
  useEffect(() => {
    if (error) {
      errorNotify(error);
      dispatch({ type: "CLEAR_ERRORS" });
    }
    dispatch(getUserOrderDetails(id));
  }, []);

  const customerAttachments = orderDetails?.data?.attachments?.find((_elem: any) => {
    if (parseInt(_elem?.attachment_type) === 0) {
      return true
    }
  })

  return (
    <div className="page_responsive">
      <div className="card">
        <div className="send_quotes_head_container" id="digitizer_order">
          <div className='send_digitizing_order_div_shorter'>
            <img src={OrderIcon} alt="pencil-logo" />
          </div>
          <h4>Order Details</h4>
        </div>
      </div>
      <div className="user_details_card">
        <Card className="order_details_card">
          {loading ? (
            <Loader />
          ) : (
            <Card.Body>
              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Order ID:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{orderDetails?.data?.order_id}</Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Order Name:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{orderDetails?.data?.order_name}</Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>

                      <Typography variant="h6">Order Date:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{moment(`${orderDetails?.data?.createdAt}Z`).format("DD-MM-YYYY")}</Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Customer Username:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {orderDetails?.data?.Customer?.username}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Customer Full Name:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {orderDetails?.data?.Customer?.first_name}{" "}
                        {orderDetails?.data?.Customer?.last_name}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Required Format:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {orderDetails?.data?.Format?.name}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Height:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{orderDetails?.data?.height}</Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Width:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{orderDetails?.data?.width}</Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Fabric:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {orderDetails?.data?.Fabric?.name}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Placement:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {orderDetails?.data?.Placement?.name}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="justify-content-around my-1">
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Number of Colors:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>{orderDetails?.data?.no_color}</Typography>
                    </Col>
                  </Row>
                </Col>
                <Col md={5} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={6}>
                      <Typography variant="h6">Super Urgent:</Typography>
                    </Col>
                    <Col md={6} className='text-end'>
                      <Typography>
                        {parseInt(orderDetails?.data?.urgent) === 0
                          ? "not-urgent"
                          : "urgent"}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="justify-content-around my-1">
                <Col md={11} className="m-1 detail_field">
                  <Row className="card_content">
                    <Col md={12}>
                      <Typography variant="h6">
                        Additional Instruction:{" "}
                      </Typography>
                      <Typography>
                        {orderDetails?.data?.additional_instruction}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>


              {
                orderDetails?.data?.attachments?.length && customerAttachments ?
                  (
                    <Row className="justify-content-around my-1">
                      <Col md={11} className="m-1">
                        <Typography variant="h4">Customer Attachments:</Typography>
                      </Col>
                    </Row>
                  )
                  : null
              }

              <Row className="justify-content-around my-1">
                {(orderDetails?.data?.attachments) &&
                  orderDetails?.data?.attachments.map(
                    (attachment: any, i: any) => {
                      if (parseInt(attachment?.attachment_type) === 0) {
                        return (
                          <Col md={11} className="m-1 detail_field">
                            <Row className="align-items-center">
                              <Col md={4}>
                                <Typography variant="h6">File {i + 1}:</Typography>
                              </Col>
                              <Col md={4}>
                                <Typography className="text-center">
                                  {attachment.attachment_name}
                                </Typography>
                              </Col>
                              <Col md={4} className="d-flex justify-content-end">
                                <button className="download_btn" onClick={() => downloadS3File(attachment?.attachment_file)}>
                                  <FaDownload /> Download
                                </button>
                              </Col>
                            </Row>
                          </Col>
                        )
                      }
                    }
                  )}
              </Row>



              {(parseInt(orderDetails?.data?.digitizer_order_status) === 1 && orderDetails?.data?.attachments) && (
                <Row className="justify-content-around my-1">
                  <Col md={11} className="m-1">
                    <Typography variant="h4">Digitizer Attachments:</Typography>
                  </Col>
                </Row>
              )}
              <Row className="justify-content-around my-1">
                {(orderDetails?.data?.attachments && parseInt(orderDetails?.data?.digitizer_order_status) === 1) &&
                  orderDetails?.data?.attachments.map(
                    (attachment: any, i: any) => {
                      if (parseInt(attachment?.attachment_type) === 1) {
                        return (
                          <Col md={11} className="m-1 detail_field">
                            <Row className="align-items-center">
                              <Col md={4}>
                                <Typography variant="h6">File {i + 1}:</Typography>
                              </Col>
                              <Col md={4}>
                                <Typography className="text-center">
                                  {attachment.attachment_name}
                                </Typography>
                              </Col>
                              <Col md={4} className="d-flex justify-content-end">
                                <button className="download_btn" onClick={() => downloadS3File(attachment?.attachment_file)}>
                                  <FaDownload /> Download
                                </button>
                              </Col>
                            </Row>
                          </Col>
                        )
                      }
                    }
                  )}
              </Row>

              <Row className="pt-4 justify-content-end">
                <Col xs={12} md={5} className='button_container_main '>
                  <button
                    className="my-1 details_btn bg-gray"
                    onClick={() => navigate("/digitizer/orders")}
                  >
                    Go Back
                  </button>

                  {
                    parseInt(digitizerStatus) === 0 ?
                      <button className="my-1 details_btn sent_order" onClick={() => navigate(`/digitizer/attachment-upload/${id}`)}>
                        Order Upload
                      </button>
                      :
                      <button className="my-1 details_btn sent_order" id='disabled_btn' disabled>
                        Sent Order
                      </button>
                  }
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    </div>
  );
};

export default OrderDetails;
